import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Space, Spin, Typography } from 'antd';
import Accordion from 'components/Accordion';
import useAgTaskQuery from 'screens/task-management/hooks/queries/useAgTaskQuery';
import useTaskManagementFilters from 'screens/task-management/hooks/useTaskManagementFilters';
import TasksTable from '../components/TasksTable';
import { TaskManagementContext } from 'screens/task-management';
import { useOutletContext } from 'react-router-dom';
import { number } from 'utils/valueRenderer';

const AgronomistViewContent = () => {
  const { filters } = useTaskManagementFilters();
  const { handleTaskRowClick } = useOutletContext<TaskManagementContext>();

  const { flattenedData, isLoading } = useAgTaskQuery(filters);

  return (
    <Space direction="vertical">
      {isLoading && (
        <Flex justify="center" align="center">
          <Spin
            indicator={<LoadingOutlined spin />}
            spinning={isLoading}
            size="large"
          />
        </Flex>
      )}
      {flattenedData?.map((item, index) => (
        <Accordion
          key={index}
          className="accordion-card"
          title={
            <Typography.Title className="m-0" level={5}>
              {item.agronomistName || 'No Name'}
            </Typography.Title>
          }
          itemKey={String(index)}
          headerContent={
            <Space>
              <span>{number(item?.failedCount)} Failed</span>
              <span>{number(item?.overdueCount)} Overdue</span>
              <span>{number(item?.activeCount)} Active</span>
              <span>{number(item?.completedCount)} Completed</span>
            </Space>
          }
          iconPrefixContent={
            <Typography.Text>{number(item.taskList?.length)}</Typography.Text>
          }
          defaultActiveKey={String(index)}
          style={{ background: 'transparent' }}
        >
          <TasksTable
            onRowClick={handleTaskRowClick}
            hiddenColumnKeys={['agronomistName']}
            data={item.taskList}
            loading={isLoading}
          />
        </Accordion>
      ))}
    </Space>
  );
};

export default AgronomistViewContent;
